import * as c from '../constants/GenerateAPIDConstants'
import template from './template'

const initialState = {
  submiting: false,
  submitted: false,
  error: null,
  data: {},
}

export const generateAPID = (state = initialState, { type, payload }) => {
  switch (type) {
    case c.SUBMIT_GENERATE_APID_PENDING:
      return { ...state, submitting: true, submitted: false, error: null }

    case c.SUBMIT_GENERATE_APID_FULFILLED:
      return { ...state, submitting: false, submitted: true, data: payload }

    case c.SUBMIT_GENERATE_APID_REJECTED:
      return { ...state, submitting: false, submitted: false, error: payload }

    default:
      return state
  }
}

export const generatedAPIDs = (state, action) => template(state, action, c, 'GENERATED_APIDS')
